import { render, staticRenderFns } from "./AccountsCreate.vue?vue&type=template&id=3d4ce7fa&scoped=true"
import script from "./AccountsCreate.vue?vue&type=script&lang=js"
export * from "./AccountsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ce7fa",
  null
  
)

export default component.exports